import { render } from "./Book.vue?vue&type=template&id=5e7f5bd0"
import script from "./Book.vue?vue&type=script&lang=js"
export * from "./Book.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/sites/qiyas.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__